<template>
    <div class="details">
        <div>建设单位：{{ projectOverview.constructionUnit }}</div>
        <div>EPC总承包单位：{{ projectOverview.EPCGeneralContractingUnit }}</div>
        <div>设计单位：{{ projectOverview.designUnit }}</div>
        <div>监理单位：{{ projectOverview.supervisionUnit }}</div>
        <div style="display: flex;margin: 2vh 0;padding: 0">
            <div class="conTractPeriod around-center">
                <div>合同工期</div>
                <div>{{ projectOverview.conTractPeriod }}</div>
            </div>
            <div style="left: 1vw" class="conTractPeriod around-center">
                <div>完工倒计时</div>
                <div>{{ projectOverview.countdownToCompletion }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'projectOverview',

    props: {
        projectOverview: {
            constructionUnit: String,
            EPCGeneralContractingUnit: String,
            designUnit: String,
            supervisionUnit: String,
            conTractPeriod: String,
            countdownToCompletion: String,
        }
    },
}
</script>

<style lang="less" scoped>
.details {
    width: 28.54vw;
    height: 24.5vh;
    left: 16px;
    padding-top: 0.5vh;
    > div:nth-child(1n) {
        font-size: 14px;
        color: #FFFFFF;
        text-align: left;
        padding: 0.5vh 0;
    }
}

.conTractPeriod {
    width: 12vw;
    height: 36px;
    background: rgba(5, 77, 165, 0.01);
    box-sizing: border-box;
    border: 1px solid #1051CE;
    box-shadow: inset 0px 4px 43px 0px #054DA5;
    div {
        font-size: 14px;
    }
    :first-child {
        color: #FFFFFF;
	}
    :last-child {
        color: #01FFFF;
    }
}
</style>
